import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import ProjectGateway from '~apis/project';
import { TGetProjectDetailsReduxParams } from '~types/feat/project';

export default function* watchGetProjectDetails(api: ProjectGateway): SagaWatcherReturnType {
    yield takeEvery('project/projectGetProjectDetailsAttempt', handleGetProjectDetails, api);
}

function* handleGetProjectDetails(api: ProjectGateway, data: PayloadAction<TGetProjectDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const { projectId } = data.payload;

    if (!projectId) {
        yield put(combinedActions.projectGetProjectDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.getProjectDetails], {
        authToken,
        projectId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.projectGetProjectDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const {
            data: responseData,
        } = response;

        yield put(combinedActions.projectGetProjectDetailsSuccess(responseData));
    }
}
